export default __webpack_public_path__ + "static/media/Location_Nordrhein-Westfalen.ad7cef1a.svg";